<script setup>
import { arrDepth, ensureRef, fetchImgData, get, isImgFile, isSameCoord, loadEpsgs, loadEpsgsWithPrjInit, openWin, post, postMultipart, qsel, senitizeLonLatBbox, serverDt, toJson, twoDemArr, validators, ymd, ymdhm } from '@/common/util'
import MenuLayout from '@/pages/layout/MenuLayout.vue'
import { useMetaStore } from '@/stores'
import proj4 from 'proj4'
import { onMounted, onUnmounted, reactive } from 'vue'
import { useRouter,useRoute } from 'vue-router'
import { Pane, Splitpanes } from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'
import Vue3TreeVue from 'vue3-tree-vue'
import draggableComponent from 'vuedraggable'
import DataDetail from '@/components/member/DataDetail.vue'
import Logs from '@/components/admin/config/Logs.vue'
import _ from 'lodash-es'
import { register } from 'ol/proj/proj4'
import TileLayer from 'ol/layer/Tile'
import MousePosition from 'ol/control/MousePosition'
import {defaults as defaultControls} from 'ol/control/defaults.js'
import { Feature, Map, View } from 'ol'
import { createStringXY } from 'ol/coordinate'
import LayerGroup from 'ol/layer/Group'
import { ImageWMS, OSM, XYZ } from 'ol/source'
import ZoomSlider from 'ol/control/ZoomSlider'
import config from '@/common/config'
import { transformExtent } from 'ol/proj'
import { buffer } from 'ol/extent'
import VectorLayer from 'ol/layer/Vector'
import VectorSource from 'ol/source/Vector'
import GeoJSON from 'ol/format/GeoJSON.js';
import Select from 'ol/interaction/Select'
import Draw from 'ol/interaction/Draw'
import Modify from 'ol/interaction/Modify'
import Snap from 'ol/interaction/Snap'
import { Circle, Fill, Stroke, Style } from 'ol/style'
import MemPicker from '@/components/MemPicker.vue'
import ConfirmCard from '@/components/ConfirmCard.vue'
import WKT from 'ol/format/WKT'
import { ref } from 'vue'
import dayjs from 'dayjs'
import { Point } from 'ol/geom'
import ImageLayer from 'ol/layer/Image'
import BgMapSelector from '@/components/BgMapSelector.vue'
import Cookies from "js-cookie"
const fidnm='featureid'
const route=useRoute(),router=useRouter(),metaStore=useMetaStore(),meta=reactive({showleft:true,showright:true,treeshown:true,groups:[],layers:[],data:[],mapsvs:[],inters:{},modeditfeatures:{creates:[],dels:[],mods:[]}
  ,styleheads:[{tk:'preview'},{tk:'groupname',col:'groupid'},{tk:'stylename',col:'nm'},{tk:'registrationmodificationdate',col:'mdt'}],selpano:{},seldetailtab:'svinfo',editmode:'add',subeditmode:'Node'})
,modpanoimg=ref(null),bgselector=ref(null)
,toList=()=>{
  router.push('/admin/mandata/registermanageroadview')
},openManStyle=async()=>{
  openWin(config.frontRoot+'admin/mandata/managestyles')
},panoViewerSingle=(id,ang,angv)=>{
  if(!angv)angv=0
  openWin(config.backend+'panosingle/'+id+'/false/'+ang+'/'+angv)
},panoViewerCompare=(ang,angv)=>{
  if(!angv)angv=0
  openWin(config.backend+'panocompare/'+meta.selfid+'/false/'+ang+'/'+angv)
},previewPanoImg=async()=>{
  modpanoimg.value.style.display='none'
  if(!meta.selpano.upimgpano)return modpanoimg.value.src=null
  if(!isImgFile(meta.selpano.upimgpano.name)){
    metaStore.toastKey('notimgfile',false)
    return meta.selpano.upimgpano=null
  }
  modpanoimg.value.style.display='block'
  modpanoimg.value.onload = () => {
    const width = modpanoimg.value.naturalWidth;
    const height = modpanoimg.value.naturalHeight;

    const result = {
      valid: true,
      width,
      height,
      issues: []
    };
    // 1. 비율 체크 (2:1)
    const ratio = width / height;
    if (Math.abs(ratio - 2) > 0.01) {
      metaStore.toast("2:1 비율이 아닙니다",false);
      modpanoimg.value.style.display='none'
      meta.selpano.upimgpano=null
    }

    // 2. 최소 해상도
    if (width < 2048) {
      metaStore.toast("해상도 너무 작습니다 (가로 2048px 미만)",false);
      modpanoimg.value.style.display='none'
      meta.selpano.upimgpano=null
    }

    // 3. 최대 해상도 (안전 기준)
    if (width > 16384 || height > 8192) {
      metaStore.toast("해상도 너무 큽니다 (일부 브라우저에서 문제 가능)",false);
      modpanoimg.value.style.display='none'
      meta.selpano.upimgpano=null
    }
  };
  modpanoimg.value.onerror = () => {
    metaStore.toast("이미지 로드 실패",false);
    modpanoimg.value.style.display='none'
    meta.selpano.upimgpano=null
  };
  modpanoimg.value.src=URL.createObjectURL(meta.selpano.upimgpano)
},findPanos=async()=>{
  meta.panos=null
  metaStore.blockLoading()
  const res=await get('rest/authed/member/panos/'+meta.selfid)
  metaStore.blockLoading(false)
  meta.panos=res.data
},modFeature=async (flag)=>{
  meta.modfeaturetype=null
  if(flag=='mod'){
    meta.modfeaturetype='loading'
    const featuremodel={refid:meta.selsv.id,xpos:meta.modifyfeature.coords[0],ypos:meta.modifyfeature.coords[1],memo:meta.modifyfeature.memo}
    featuremodel.cmdtype='modify'
    featuremodel.featureid=meta.selfid
    featuremodel.setptmerge=meta.modifyfeature.setptmerge
    featuremodel.overlapfids=meta.modifyfeature.overlapfids
    featuremodel.hangle=meta.modifyfeature.hangle
    featuremodel.vangle=meta.modifyfeature.vangle
    featuremodel.featurelink=meta.modifyfeature.featurelink
    if(!featuremodel.overlapfids)featuremodel.overlapfids=[]
    const res=await post('rest/authed/admin/data/modsvdetail',featuremodel)
    metaStore.toastRslt(res,true)
    if(res.isSuccess){
      modFeature()
      selTree(findItem({id:meta.selsv.id,issv:true}),true,()=>actSelFid(featuremodel.featureid))
    }else modFeature('modpop')
    return
  }
  if(flag=='del'){
    meta.modfeaturetype='loading'
    let res
    if(meta.selsv.layertype=='LineString'){
      res=await get(`rest/authed/admin/data/checklinesv/${meta.selsv.id}/Point/${meta.selfid}`)
      if(res.data&&res.data.the_geom){
        const wktFormat=new WKT()
        const linegeom=wktFormat.readFeature(res.data.the_geom)
        if(linegeom.getGeometry().flatCoordinates.length<5){
          if(!confirm('라인(전체)도 함께 지워집니다\r\n진행하시겠습니까?')){
            modFeature()
            return
          }
        }
      }
    }
    res=await post('rest/authed/admin/data/delsvdetail',{refid:meta.selsv.id,featureid:meta.selfid,layertype:meta.selsv.layertype})
    metaStore.toastRslt(res,false)
    if(res.isSuccess){
      modFeature()
      selTree(findItem({id:meta.selsv.id,issv:true}),true)
    }else modFeature('delpop')
    return
  }
  if(flag=='addpanopop')meta.selpano={imgdt:new Date,hangle:0,vangle:0}
  if(flag=='modpanopop'){
    meta.selpano.upimgpano=null
    meta.selpano.imgdt=dayjs(meta.selpano.imgdt).toDate()
    ensureRef(modpanoimg,val=>{
      val.style.display='block'
      val.src=config.backend+'pano/upimg/'+meta.selpano.id
    })
  }
  if(flag=='modpano'){
    meta.modfeaturetype='loading'
    const panodata={upimgpano:meta.selpano.upimgpano,svid:meta.selsv.id,featureid:meta.selfid,gslayernm:meta.selsv.gspointnm}
    if(meta.selpano.id)panodata.id=meta.selpano.id
    panodata.imgdt=serverDt(meta.selpano.imgdt)
    panodata.hangle=meta.selpano.hangle
    panodata.vangle=meta.selpano.vangle
    const res=await postMultipart('rest/authed/admin/data/savepano',panodata)
    metaStore.toastRslt(res,true)
    if(res.isSuccess){
      modFeature()
      findPanos()
    }else{
      if(meta.selpano.id)modFeature('modpanopop')
      else modFeature('addpanopop')
    }
    return
  }
  if(flag=='delpano'){
    meta.modfeaturetype='loading'
    const res=await post('rest/authed/admin/data/delpano',meta.selpano)
    metaStore.toastRslt(res,false)
    if(res.isSuccess){
      modFeature()
      findPanos()
    }else modFeature('delpanopop')
    return
  }
  meta.modfeaturetype=flag
  meta.featuremodpop=flag!=null
},modSv=async()=>{
  metaStore.blockLoading()
  const modmodel={sv:{...meta.selsv}}
  if(modmodel.sv.groupid=='defaultgroups')modmodel.sv.groupid=null
  modmodel.features=[]
  if(meta.onediting){
    const wktFormat=new WKT()
    _.entries(meta.modeditfeatures).forEach(ent=>ent[1].forEach(feature=>{
      const modfeature={}
      modfeature.svid=meta.selsv.id
      modfeature.featureid=feature.get(fidnm)
      modfeature.layertype=feature.getGeometry().getType()
      modfeature.cdepth=arrDepth(feature.getGeometry().getCoordinates())
      modfeature.wkt=wktFormat.writeFeature(feature,{featureProjection:meta.map.getView().getProjection(),dataProjection:'EPSG:'+meta.selsv.epsg})
      if(ent[0]=='creates')modfeature.cmdtype='create'
      if(ent[0]=='dels')modfeature.cmdtype='delete'
      if(ent[0]=='mods')modfeature.cmdtype='modify'
      modmodel.features.push(modfeature)
    }))
  }
  const res=await post('rest/authed/admin/data/modsv',modmodel)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(res.isSuccess)init(meta.selsv.id)
},shareSaved=async targettype=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/setsharesv',{id:meta.selsv.id,sharetype:targettype})
  metaStore.blockLoading(false)
  meta.selsv.sharetype=targettype
},saveSvStyle=async()=>{
  const pd={id:meta.selsv.id}
  if(meta.selstyle==='true'||meta.selstyle==='false'||meta.selstyle===true||meta.selstyle===false)pd.style=null
  else pd.style=meta.selstyle
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/styletosv',pd)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  if(!res.isSuccess)return
  meta.selsv=res.data
  meta.selstyle=meta.selsv.style
  meta.svs[meta.svs.findIndex(lyr=>lyr.id==meta.selsv.id)]=toJson(meta.selsv)
  initMapSvs()
  searchStyle()
},searchStyle=async()=>{
  if(!meta.searchstylenm)meta.searchstylenm=''
  meta.styles={rows:[]}
  const spm={page:1,size:99999,isasc:false,sortcol:'mdt',where:{nm:meta.searchstylenm}}
  spm.fields=['id','nm','groupid','mdt','gsstylenms','styletype']
  spm.where.styletype_eq_=meta.selstyletype
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/layerstyles',spm)
  metaStore.blockLoading(false)
  meta.selstyle=meta.selsv.style
  meta.styles=res.data
},populateEditLayer=async({sv,force,max=10000,bbox,layertype='Point',clearSource=true})=>{
  if(!force&&meta.onediting||meta.selfid)return
  //metaStore.blockLoading()
  qsel('.dvloading').style.display='block'
  const wpm={
    service: "WFS",
    version: "1.0.0",
    request: "GetFeature",
    typeName: layertype=='Point'?sv.gspointnm:sv.gslinenm,
    maxFeatures: 1,
    outputFormat: "application/json",
    srsName:'EPSG:'+sv.epsg
  }
  if(meta.totalFeatures==null){
    const geojson=await get('wfs',()=>{},wpm)
    meta.totalFeatures=geojson.totalFeatures
  }
  wpm.maxFeatures=max
  if(!bbox||!bbox.length)bbox=meta.map.getView().calculateExtent()
  bbox=buffer(bbox,500)
  meta.lastextent=bbox
  const calced=transformExtent(bbox,meta.map.getView().getProjection(),'EPSG:'+sv.epsg)
  wpm.bbox=calced.toString()
  const geojson=await get('wfs',()=>{},wpm)
  meta.numberMatched=geojson.numberMatched
  meta.numberReturned=geojson.numberReturned
  if(clearSource){
    meta.pteditlayer.getSource().clear()
    meta.lineeditlayer.getSource().clear()
  }
  const targetsource=layertype=='Point'?meta.pteditlayer.getSource():meta.lineeditlayer.getSource()
  targetsource.addFeatures(new GeoJSON().readFeatures(geojson,{dataProjection:'EPSG:'+meta.selsv.epsg,featureProjection: meta.map.getView().getProjection()}))
  qsel('.dvloading').style.display='none'
  //metaStore.blockLoading(false)
},debouncePopulateEditLayer=_.debounce(populateEditLayer,300)
,sub=async type=>{
  meta.subtype=null
  meta.showsub=false
  meta.subttl=null
  meta.panos=null
  meta.selpano=null
  metaStore.pop({ison:false})
  modFeature()
  if(type=='featuredetail')findPanos()
  else clearFid()
  if(type=='selstyle'){
    meta.subttl=metaStore.t('chooseastyle')
    meta.selstyletype='Streetview'
    await searchStyle()
  }
  if(type=='share'||type=='mod')return metaStore.pop({ison:true,callback:()=>meta.subtype=type})
  if(type=='log')meta.subttl=metaStore.t('viewinglayerlogs')
  if(type)meta.showsub=true
  meta.subtype=type
},delSelFeature=()=>{
  if(!meta.inters.sel)return
  meta.inters.sel.getFeatures().forEach(fea=>{
    meta.featureselected=false
    let layertype=meta.selsv.layertype
    if(layertype=='NodeLink')layertype=meta.subeditmode=='Node'?'Point':'LineString'
    const targetsource=layertype=='Point'?meta.pteditlayer.getSource():meta.lineeditlayer.getSource()
    targetsource.removeFeature(fea)
    let idx=meta.modeditfeatures.creates.indexOf(fea)
    if(idx>-1)meta.modeditfeatures.creates.splice(idx,1)
    idx=meta.modeditfeatures.mods.indexOf(fea)
    if(idx>-1)meta.modeditfeatures.mods.splice(idx,1)
    if(fea.get(fidnm)&&!meta.modeditfeatures.dels.includes(fea))meta.modeditfeatures.dels.push(fea)
    if(meta.selsv.layertype=='LineString'){
      lineToPts(fea.ol_uid,true)
    }
  })
  meta.inters.sel.getFeatures().clear()
},setSubEditMode=(type)=>{
  meta.subeditmode=type
  initInters()
  setEditMode(meta.editmode)
},setEditMode=(type)=>{
  _.keys(meta.inters).forEach(key=> meta.inters[key].setActive(false))
  meta.inters.snap.setActive(true)
  if(type=='add')meta.inters.draw.setActive(true)
  if(type=='mod'){
    meta.inters.sel?.setActive(true)
    meta.inters.mod?.setActive(true)
  }
  meta.editmode=type
},cloneView=(extent)=>{
  const oldView=meta.map.getView()
  return new View({
    center: oldView.getCenter(),
    zoom: oldView.getZoom(),
    rotation: oldView.getRotation(),
    projection: oldView.getProjection(),
    minZoom: oldView.getMinZoom(),
    maxZoom: oldView.getMaxZoom(),
    extent: extent
  })
},toggleEdit=async()=>{
  meta.modeditfeatures={creates:[],dels:[],mods:[]}
  meta.pteditlayer.setVisible(false)
  meta.lineeditlayer.setVisible(false)
  delSelFeature()
  actSelFid()
  if(meta.onediting){
    meta.map.setView(cloneView(meta.map.getView().calculateExtent()))
    if(meta.selsv.layertype=='NodeLink'){
      await populateEditLayer({sv:meta.selsv,force:true,layertype:'Point',clearSource:false})
      await populateEditLayer({sv:meta.selsv,force:true,layertype:'LineString',clearSource:false})
    }else await populateEditLayer({sv:meta.selsv,force:true,layertype:meta.selsv.layertype})
    meta.pteditlayer.setVisible(true)
    if(meta.selsv.layertype=='LineString'){
      meta.lineeditlayer.getSource().getFeatures().forEach(line=>lineToPts(line.ol_uid))
      meta.lineeditlayer.setVisible(true)
    }
  }else{
    meta.map.setView(cloneView())
    await populateEditLayer({sv:meta.selsv,force:true,layertype:'Point'})
  }
  meta.data.forEach(group=>group.children.forEach(item=>{
    item.disabled=meta.onediting
    if(item.selected)item.disabled=false
  }))
  setVisible(meta.selsv.id,!meta.onediting)
  initInters(!meta.onediting)
  if(meta.onediting){
    setEditMode('add')
    if(meta.selsv.layertype=='NodeLink'){
      meta.pteditlayer.setVisible(true)
      meta.lineeditlayer.setVisible(true)
    }
  }
},reorderTreeSv=async(item,isup)=>{
  const group = meta.data.find(gr => gr.id === item.groupid);
  if (!group || group.children.length < 2) return;
  const idx = group.children.findIndex(child => child.id === item.id);
  if (idx === -1) return;
  if (isup) {
    if (idx === 0) return;
    [group.children[idx - 1], group.children[idx]] = [group.children[idx], group.children[idx - 1]];
  } else {
    if (idx === group.children.length - 1) return;
    [group.children[idx], group.children[idx + 1]] = [group.children[idx + 1], group.children[idx]];
  }
  const svorderingroup=[]
  group.children.forEach((sv,idx)=>svorderingroup.push({id:sv.id,order:idx}))
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/setsvorders',svorderingroup)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
},treeCheck=item=>{
  const searched=findItem(item)
  const checked=!searched.checked
  if(!searched.issv)searched.children.forEach(sv=>sv.checked=checked)
  searched.checked=checked
  meta.mapsvs=[]
  meta.data.forEach(group=>group.children.forEach(sv=>{
    if(sv.checked||sv.selected){
      sv.checked=true
      meta.mapsvs.push({nm:sv.name,id:sv.id,shown:true})
    }
  }))
  initMapSvs()
},layerDragEnd=()=>{
  initMapSvs()
},selTree=async(item,force,callback)=>{
  if(!item.issv)return
  if(force)meta.data.forEach(group=>group.children.forEach(sv=>sv.selected=false))
  if(item.issv&&item.selected){
    meta.showdetail=true
    if(callback)callback()
    return
  }
  meta.onediting=false
  meta.selsv=meta.svs.find(sv=>sv.id==item.id)
  meta.blockdetail=meta.selsv.processstatus!='complete'
  meta.showdetail=true
  item.selected=true
  item.checked=true
  findItem({id:item.groupid,issv:false}).expanded=true
  treeCheck(item)
  meta.totalFeatures=null
  await populateEditLayer({sv:meta.selsv,force:true})
  await toggleEdit()
  clearFid()
  const lyrnm='sv_point_'+item.id
  const bbox=meta.bboxes&&meta.bboxes[lyrnm]
  const padding=[700,700,700,700]
  if(bbox){
    meta.map.getView().fit(bbox,{padding:[100,100,100,100],callback:()=>{
      if(meta.map.getView().getZoom()>19)meta.map.getView().setZoom(19)
    }})
  }else metaStore.toast('해당 레이어의 영역정보가 없습니다.',false)
  if(callback)callback()
},filterLayer=txt=>{
  meta.data=toJson(meta.odata)
  const delids={}
  if(!_.isEmpty(txt))meta.data.forEach((group,gidx)=>group.children.forEach(sv=>{
    if(!sv.name.toLowerCase().includes(txt.toLowerCase())){
      if(!delids[gidx])delids[gidx]=[]
      delids[gidx].push(sv.id)
    }
  }))
  _.keys(delids).forEach(idx=>meta.data[idx].children=meta.data[idx].children.filter(sv=>!delids[idx].includes(sv.id)))
},clearFid=()=>{
  meta.selfid=null
  let radio=qsel('[name=selfid]:checked')
  if(radio)radio.checked=false
  meta.detaillayer.getSource().clear()
  meta.modifyfeature={coords:[]}
},featureByFid=(source,fid)=>{
  return source.getFeatures().find(fea=>fea.get(fidnm)==fid)
},actSelFid=fid=>{
  clearFid()
  const ptsource=meta.pteditlayer.getSource()
  if(fid==null)return sub()
  if(fid==meta.selfid){
    meta.map.getView().setCenter(getCenter(featureByFid(ptsource,fid).getGeometry().getExtent()))
    return
  }
  const feature=featureByFid(ptsource,fid).clone()
  if(feature.get('mergefid'))fid=feature.get('mergefid')
  meta.map.getView().setCenter(feature.getGeometry().getCoordinates())
  meta.selfid=fid
  sub('featuredetail')
  let radio=qsel('[value="'+fid+'"]')
  radio.checked=true
  radio.scrollIntoView({block: 'center'})
  meta.disablemapevt=true
  meta.detaillayer.getSource().addFeature(feature.clone())
  meta.disablemapevt=false
  const featuresonpt=ptsource.getFeaturesAtCoordinate(feature.getGeometry().getCoordinates())
  const difflineonpt=_.uniqBy(featuresonpt,fea=>fea.get('linefid'))
  meta.modifyfeature.overlapped=difflineonpt.length>1
  if(meta.modifyfeature.overlapped)meta.modifyfeature.overlapfids=featuresonpt.map(fp=>fp.get(fidnm))
  else meta.modifyfeature.overlapfids=null
  meta.modifyfeature.setptmerge=feature.get('mergefid')!=null
  feature.getGeometry().transform(meta.map.getView().getProjection(),'EPSG:'+meta.selsv.epsg)
  meta.modifyfeature.featureid=fid
  meta.modifyfeature.memo=feature.get('memo')
  meta.modifyfeature.hangle=feature.get('hangle')
  meta.modifyfeature.vangle=feature.get('vangle')
  if(!meta.modifyfeature.vangle)meta.modifyfeature.vangle=0
  meta.modifyfeature.layertype=feature.getGeometry().getType()
  meta.modifyfeature.coords=feature.getGeometry().getCoordinates()
  meta.modifyfeature.cdepth=arrDepth(meta.modifyfeature.coords)
  get('rest/authed/member/featurelink/streetview/'+fid,res=>{
    if(!res.data.id)return
    meta.modifyfeature.featurelink=res.data.url
  })
},setVisible=(id,visible)=>{
  let mlayer
  meta.layergroup.getLayers().forEach(lyr=>{
    if(lyr.get('svid')==id)mlayer=lyr
  })
  if(mlayer)mlayer.setVisible(visible)
},findItem=({id,issv})=>{
  let item
  if(issv)meta.data.forEach(group=>group.children.forEach(sv=>{
    if(sv.id==id)item=sv
  }))
  else meta.data.forEach(group=>{
    if(group.id==id)item=group
  })
  return item
},toggleArrowStyle=()=>{
  meta.layergroup.getLayersArray().forEach(lyr=>lyr.getSource().refresh())
},initMapSvs=clear=>{
  meta.layergroup.getLayers().clear()
  if(clear)return
  meta.mapsvs.toReversed().forEach(item=>{
    const sv=meta.svs.find(sv=>sv.id==item.id)
    const params={LAYERS:sv.gspointnm}
    if(!_.isEmpty(sv.style)){
      const arr=sv.style.split(',')
      const ptstyle=arr.find(sty=>sty.includes('_point'))
      const linestyle=arr.find(sty=>sty.includes('_line'))
      params.STYLES=ptstyle
      if(sv.layertype=='LineString'||sv.layertype=='NodeLink'){
        params.STYLES+=','+linestyle
      }
    }
    if(sv.layertype=='LineString'||sv.layertype=='NodeLink')params.LAYERS+=','+sv.gslinenm
    const mapsv=new ImageLayer({source:new ImageWMS({
      url: config.backend+'wms',
      params,serverType: 'geoserver',
      imageLoadFunction: async(image, src) => {
        if(meta.isarrow){
          const temp=src.split('?')
          const searchParams=new URLSearchParams(temp[1])
          searchParams.delete('STYLES')
          src=temp[0]+'?'+searchParams.toString()
          const nms=searchParams.get('LAYERS').split(',')
          const sld=`<?xml version="1.0" encoding="UTF-8"?>
            <StyledLayerDescriptor xmlns="http://www.opengis.net/sld" xmlns:ogc="http://www.opengis.net/ogc" xmlns:xlink="http://www.w3.org/1999/xlink"
              xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" version="1.0.0" xsi:schemaLocation="http://www.opengis.net/sld http://schemas.opengis.net/sld/1.0.0/StyledLayerDescriptor.xsd">
              <NamedLayer>
                <Name>${nms[0]}</Name>
                <UserStyle>
                  <FeatureTypeStyle>
                    <Rule>
                      <PointSymbolizer>
                        <Graphic>
                          <Size>32</Size>
                          <Rotation>
                            <PropertyName>hangle</PropertyName>
                          </Rotation>
                          <Mark>
                            <WellKnownName>ttf://Material Icons#U+e5d8</WellKnownName>
                            <Fill>
                              <CssParameter name="fill">#0000FF</CssParameter>
                              <CssParameter name="fill-opacity">1</CssParameter>
                              <CssParameter name="stroke-opacity">1</CssParameter>
                            </Fill>
                          </Mark>
                          <Opacity>1</Opacity>
                          <AnchorPoint>
                            <AnchorPointX>0.5</AnchorPointX>
                            <AnchorPointY>0</AnchorPointY>
                          </AnchorPoint>
                        </Graphic>
                      </PointSymbolizer>
                    </Rule>
                  </FeatureTypeStyle>
                </UserStyle>
              </NamedLayer>
              ${nms.length>1?`<NamedLayer>
                <Name>${nms[1]}</Name>
                <UserStyle>
                  <FeatureTypeStyle>
                    <Rule>
                      <LineSymbolizer>
                        <Stroke>
                          <CssParameter name="stroke">#0000FF</CssParameter>
                          <CssParameter name="stroke-width">1</CssParameter>
                        </Stroke>
                      </LineSymbolizer>
                    </Rule>
                  </FeatureTypeStyle>
                </UserStyle>
              </NamedLayer>`:''}
            </StyledLayerDescriptor>`
          image.getImage().src = await fetchImgData(src,sld)
        }else{
          image.getImage().src=src
        }
      }
    })})
    mapsv.set('svid',item.id)
    mapsv.setVisible(item.shown)
    mapsv.getSource().on('imageloaderror', function (event) {
      metaStore.toast(`로드 에러:데이터/스타일을 확인해 주세요`,false)
    })
    if(meta.onediting&&item.id==meta.selsv.id)mapsv.setVisible(false)
    meta.layergroup.getLayers().push(mapsv)
  })
},lineToPts=(uid,deleted)=>{
  const ptsource=meta.pteditlayer.getSource(),linesource=meta.lineeditlayer.getSource()
  ptsource.removeFeatures(ptsource.getFeatures().filter(pt=>pt.get('lineuid')==uid))
  if(deleted)return
  let line=linesource.getFeatures().find(feature=>feature.ol_uid==uid)
  let iscreatingline=false
  if(!line){
    line=meta.editlinefeature
    uid=meta.editlinefeature.ol_uid
    iscreatingline=true
  }
  const pts=[]
  // if(line.getGeometry().getType()=='MultiLineString'){

  // }
  twoDemArr(line.getGeometry().flatCoordinates,2).forEach(coord=>{
    const ptfea=new Feature({geometry:new Point(coord)})
    ptfea.set('lineuid',uid)
    pts.push(ptfea)
  })
  if(iscreatingline)pts.pop()
  meta.pteditlayer.getSource().addFeatures(pts)
},getSelTypeAndLayer=()=>{
  let layertype=meta.selsv.layertype
  if(layertype=='NodeLink')layertype=meta.subeditmode=='Node'?'Point':'LineString'
  const layer=layertype=='Point'?meta.pteditlayer:meta.lineeditlayer
  return {type:layertype,layer:layer}
},setLinkPosProps=(linkfeature)=>{
  const coords=linkfeature.getGeometry().flatCoordinates
  linkfeature.set('stx',coords[0])
  linkfeature.set('sty',coords[1])
  linkfeature.set('edx',coords[2])
  linkfeature.set('edy',coords[3])
},initInters=(clear)=>{
  _.keys(meta.inters).forEach(key=>meta.map.removeInteraction(meta.inters[key]))
  meta.inters={}
  meta.featureselected=null
  if(clear)return
  let typenlyr=getSelTypeAndLayer()
  meta.inters.sel=new Select({style:meta.vectorselstyle,layers:[typenlyr.layer]})
  meta.inters.sel.on('select',evt=>{
    meta.featureselected=meta.inters.sel.getFeatures().getArray().length>0
  })
  meta.inters.draw=new Draw({type:typenlyr.type})
  meta.inters.draw.on('drawstart',evt=>{
    if(meta.selsv.layertype=='LineString')meta.editlinefeature=evt.feature
  })
  meta.inters.draw.on('drawend',evt=>{
    meta.inters.sel.getFeatures().clear()
    evt.feature.set('created',true)
    meta.modeditfeatures.creates.push(evt.feature)
    meta.editlinefeature=null
    if(meta.selsv.layertype=='LineString'){
      setTimeout(() =>lineToPts(evt.feature.ol_uid),100)
    }
    const coords = evt.feature.getGeometry().getCoordinates();
    if(meta.selsv.layertype=='NodeLink'&&meta.subeditmode=='Node'){
      if(meta.pteditlayer.getSource().getFeaturesAtCoordinate(coords).length>0)
        return metaStore.toast('같은 곳에 노드를 만들 수 없습니다.',false)
    }
    if(meta.selsv.layertype=='NodeLink'&&meta.subeditmode=='Link'){
      if(coords.length>2)return metaStore.toast('꼭지점은 2개이상 만들 수 없습니다',false)
      const snodes=meta.pteditlayer.getSource().getFeaturesAtCoordinate(coords[0])
      const enodes=meta.pteditlayer.getSource().getFeaturesAtCoordinate(coords[1])
      if(!snodes.length||!enodes.length){
        return metaStore.toast('노드(점)을 서로 연결할 수 없어, 연결된 선은 삭제 처리 됩니다.',false)
      }
      setLinkPosProps(evt.feature)
    }
    getSelTypeAndLayer().layer.getSource().addFeature(evt.feature)
  })
  if(meta.selsv.layertype!='NodeLink'||meta.subeditmode=='Node'){
    meta.inters.mod=new Modify({features:meta.inters.sel.getFeatures()})
    meta.inters.mod.on('modifystart', function (evt) {
      evt.features.forEach(feature => {
        const geometry = feature.getGeometry()
        if (geometry&&meta.selsv.layertype=='NodeLink'&&meta.subeditmode=='Node'){
          feature.tarmodlinks=[]
          meta.lineeditlayer.getSource().getFeaturesAtCoordinate(geometry.getCoordinates()).forEach(line=>{
            const type=line.getGeometry().getType()
            const linkcoords=type.startsWith('Multi')?line.getGeometry().getCoordinates()[0]:line.getGeometry().getCoordinates()
            const idx=linkcoords.findIndex(linkcoord=>isSameCoord(geometry.getCoordinates(),linkcoord))
            feature.tarmodlinks.push({type:type,feature:line,coordidx:idx})
          })
        }
      })
    });
    meta.inters.mod.on('modifyend',evt=>{
      evt.features.forEach(fea=>{
        if(meta.selsv.layertype=='NodeLink'&&meta.subeditmode=='Node'&&fea.tarmodlinks){
          fea.tarmodlinks.forEach(tar=>{
            const link=tar.feature
            const linkcoords=link.getGeometry().clone().getCoordinates()
            const newptcoord=fea.getGeometry().clone().getCoordinates()
            if(tar.type.startsWith('Multi'))linkcoords[0][tar.coordidx]=newptcoord
            else linkcoords[tar.coordidx]=newptcoord
            link.getGeometry().setCoordinates(linkcoords)
            setLinkPosProps(link)
            console.log('meta.modeditfeatures.mods.includes(link)',meta.modeditfeatures.mods.includes(link))
            if(!meta.modeditfeatures.mods.includes(link))meta.modeditfeatures.mods.push(link)
          })
        }
        if(!fea.get('created')){
          fea.set('modified',true)
          if(!meta.modeditfeatures.mods.includes(fea))meta.modeditfeatures.mods.push(fea)
        }
        if(meta.selsv.layertype=='LineString'){
          setTimeout(()=>lineToPts(fea.ol_uid),100)
        }
      })
    })
  }
  if(meta.selsv.layertype=='NodeLink'){
    meta.inters.snap=new Snap({source:meta.pteditlayer.getSource()})
  }else meta.inters.snap=new Snap({source:typenlyr.layer.getSource()})
  _.keys(meta.inters).forEach(key=>meta.map.addInteraction(meta.inters[key]))
},abortDrawing=()=>{
  if(!meta.inters.draw)return
  meta.inters.draw.abortDrawing()
  if(meta.editlinefeature){
    const ptsource=meta.pteditlayer.getSource()
    ptsource.getFeatures().filter(feature => feature.get('lineuid') === meta.editlinefeature.ol_uid).forEach(pt=>ptsource.removeFeature(pt))
  }
},initMap=()=>{
  meta.vectorstyle=(feature,res)=>{
    let color='rgba(90, 90, 90, 1.0)',fillcolor='rgba(200, 200, 200, 1.0)'
    if(feature.get('modified')){
      color='rgba(255, 140, 0, 1.0)'
      fillcolor='rgba(120, 60, 0, 1.0)'
    }
    if(feature.get('created')){
      color='rgba(255, 50, 50, 1.0)'
      fillcolor='rgba(150, 0, 0, 1.0)'
    }
    const fill=new Fill({color: fillcolor})
    const style=new Style({fill: fill,stroke: new Stroke({color: color,width: 3})})
    style.setImage(new Circle({fill:fill,stroke:style.getStroke(),radius:5}))
    return style
  }
  meta.vectorselstyle=(feature,res)=>{
    const fill=new Fill({color: 'rgba(0, 90, 255, 1.0)'}),stroke=new Stroke({color: 'rgba(0, 30, 120, 1.0)',width:3})
    return new Style({fill:fill,stroke:stroke,image:new Circle({fill:fill,stroke:stroke,radius:5})})
  }
  const layergroup=new LayerGroup()
  meta.pteditlayer=new VectorLayer({source:new VectorSource(),style:meta.vectorstyle,visible:false})
  meta.lineeditlayer=new VectorLayer({source:new VectorSource(),style:meta.vectorstyle,visible:false})
  meta.detaillayer=new VectorLayer({source:new VectorSource(),style:meta.vectorselstyle})
  const basemapgroup=new LayerGroup()
  basemapgroup.set('nm','basemapgroup')
  meta.map=new Map({layers:[basemapgroup,layergroup,meta.detaillayer,meta.lineeditlayer,meta.pteditlayer],target:'editmap',view:new View()
    ,controls:defaultControls().extend([new ZoomSlider(),new MousePosition({projection:'EPSG:4326',coordinateFormat: createStringXY(4)})])})
  meta.basemapgroup=basemapgroup
  meta.layergroup=layergroup
  let ext=[config.KoreaBbox.lonMin,config.KoreaBbox.latMin,config.KoreaBbox.lonMax,config.KoreaBbox.latMax]
  ext=transformExtent(ext,'EPSG:4326',meta.map.getView().getProjection())
  meta.map.getView().fit(ext)
  meta.map.on('moveend',evt=>{
    if(meta.disablemapevt||!meta.selsv)return
    debouncePopulateEditLayer({sv:meta.selsv})
    //console.log(evt)
  })
  meta.map.getView().on('change:resolution',evt=>{
    if(meta.disablemapevt)return
    debouncePopulateEditLayer({sv:meta.selsv})
  })
  meta.map.getView().on('change:center',evt=>{
    if(meta.disablemapevt)return
    debouncePopulateEditLayer({sv:meta.selsv})
  })
  meta.map.on('singleclick',evt=>{
    if(meta.onediting&&meta.editlinefeature){
      lineToPts()
    }
    if(meta.onediting||!meta.showdetail)return
    meta.map.getTargetElement().style.pointerEvents = 'none'
    meta.pteditlayer.setOpacity(0)
    meta.pteditlayer.setVisible(true)
    meta.disablemapevt=true
    setTimeout((map,pixel) => {
      const features=map.getFeaturesAtPixel(pixel,{layerFilter:layer=>layer==meta.pteditlayer})
      meta.pteditlayer.setOpacity(1)
      meta.pteditlayer.setVisible(false)
      if(features.length){
        let sfid=features[0].get(fidnm)
        if(features[0].get('mergefid'))sfid=features[0].get('mergefid')
        actSelFid(sfid)
      }else actSelFid()
      meta.map.getTargetElement().style.pointerEvents = 'auto'
      meta.disablemapevt=false
    },100,evt.map,evt.pixel)
  })
  meta.map.getViewport().addEventListener('contextmenu',evt=>{
    if(meta.onediting){
      evt.preventDefault()
      abortDrawing()
    }
  })
},init=async(id)=>{
  meta.treeshown=false
  meta.selsv=null
  metaStore.blockLoading()
  meta.onediting=false
  meta.seldetailtab='svinfo'
  let res=await get('rest/authed/member/groups/Streetview')
  meta.groups=_.sortBy(res.data.map(group=>({name:group.nm,id:group.id,gorder:group.gorder,children:[],selected:false,checked:false})),'gorder')
  res=await post('rest/authed/member/streetviews')
  meta.svs=_.sortBy(res.data,'order')
  meta.data=[...meta.groups]
  meta.data.unshift({name:metaStore.t('defaultgroups'),id:'defaultgroups',gorder:-1,children:[],selected:false,checked:false})
  meta.data.forEach(item=>item.disabled=true)
  meta.svs.forEach(sv=>{
    if(sv.groupid===null)sv.groupid='defaultgroups'
    const item={name:sv.nm,id:sv.id,groupid:sv.groupid,layertype:sv.layertype,issv:true,selected:false,checked:false}
    if(sv.processstatus!='complete'){
      item.name+=`(${metaStore.t(sv.processstatus)})`
      item.disabled=true
    }
    meta.data.find(group=>group.id==sv.groupid).children.push(item)
  })
  meta.odata=toJson(meta.data)
  loadEpsgsWithPrjInit(async epsgs=>{
    meta.epsgs=epsgs
    if(!meta.map)initMap()
    metaStore.blockLoading(false)
    fetch(config.backend+'wms?REQUEST=GetCapabilities').then(response => response.text()).then(str => {
      const parser = new DOMParser()
      const xmlDoc = parser.parseFromString(str, 'application/xml')
      meta.bboxes={}
      xmlDoc.querySelector('Layer').querySelectorAll('Layer').forEach(lyrcapa=>{
        const ttl=lyrcapa.querySelector('Title').textContent
        if(!ttl.includes('sv_'))return
        let bbox=lyrcapa.querySelector('BoundingBox')
        //const crs=bbox.getAttribute('CRS')
        const crs='EPSG:4326'
        const minx=bbox.getAttribute('minx')
        const miny=bbox.getAttribute('miny')
        const maxx=bbox.getAttribute('maxx')
        const maxy=bbox.getAttribute('maxy')
        bbox=senitizeLonLatBbox(minx,miny,maxx,maxy)
        try{
          if(bbox.some(a=>a=='-1.0E-4'))throw new Error('invalid bbox -1.0E-4')
          bbox=[parseFloat(minx),parseFloat(miny),parseFloat(maxx),parseFloat(maxy)]
          bbox=transformExtent(bbox,crs,meta.map.getView().getProjection())
          if(bbox&&!bbox.toString().includes('Infinity'))meta.bboxes[ttl]=bbox
        }catch(e){
          console.log('bbox error',ttl,e.message)
          return
        }
      })
      meta.treeshown=true
      if(id)selTree(findItem({id:id,issv:true}))
    })
  })
}
onMounted(()=>{
  Cookies.set('admdatamenu','registermanageroadview')
  init(route.params.id)
  meta.winkeyup=evt=>{
    if(!meta.onediting)return
    if(evt.key=='Delete')delSelFeature()
    if(evt.key=='Escape')abortDrawing()
  }
  window.addEventListener('keyup',meta.winkeyup)
})
onUnmounted(()=>{
  if(!meta.map)meta.map.setTarget(null)
  window.removeEventListener('keyup',meta.winkeyup)
})
</script>
<template>
  <MenuLayout>
    <div class="editsv">
      <div class="dvloading" style="position: absolute;z-index: 9999;right: 50px;top: 10px;display: none;">populating...</div>
      <div v-if="meta.showleft" class="editsv_left">
        <v-card flat class="me-2">
          <v-card-title>
            <v-row no-gutters>
              <v-col cols="2"><v-btn variant="text" density="compact" icon="mdi-arrow-left" @click="toList"/></v-col>
              <v-col>{{$t('streetview_list')}}</v-col>
            </v-row>
          </v-card-title>
          <v-divider/>
          <v-card-text class="pa-1">
            <Splitpanes horizontal class="default-theme">
              <Pane size="60">
                <v-text-field hide-details clearable variant="outlined" density="compact" class="mt-3 mb-2" :label="$t('streetview_name')" :placeholder="$t('enteralayername')" @update:model-value="filterLayer"/>
                <Vue3TreeVue v-if="meta.treeshown" class="editsvtree" :items="meta.data" @onSelect="selTree">
                  <template #item-prepend-icon="item">
                    <v-icon v-if="!item.issv" icon="mdi-folder"/>
                    <v-icon v-else-if="item.layertype.includes('Point')" icon="mdi-vector-point"/>
                    <v-icon v-else-if="item.layertype.includes('Line')" icon="mdi-vector-line"/>
                    <v-icon v-else-if="item.layertype.includes('NodeLink')" icon="mdi-link"/>
                  </template>
                  <template #item-prepend="item">
                    <v-checkbox hide-details density="compact" :model-value="item.checked" :disabled="item.selected" @click.stop="treeCheck(item)"/>
                  </template>
                  <template #item-append="item">
                    <div v-if="item.issv" class="flex-grow-1 text-right" style="width: 80px;">
                      <v-btn icon="mdi-arrow-up-bold" size="x-small" variant="text" color="primary" @click.stop="reorderTreeSv(item,true)"/>
                      <v-btn icon="mdi-arrow-down-bold" size="x-small" variant="text" color="secondary" @click.stop="reorderTreeSv(item,false)"/>
                    </div>
                  </template>
                </Vue3TreeVue>
              </Pane>
              <Pane v-if="meta.selbgmid" size="40" style="overflow-y: auto;">
                <p class="text-center pt-2 pb-2 bg-purple-darken-2">{{ $t('layervieworder') }}</p>
                <v-divider/>
                <draggableComponent v-model="meta.mapsvs" item-key="id" @end="layerDragEnd">
                  <template #item="{element}">
                    <v-alert block border="start" density="compact" :icon="element.shown?'mdi-eye-outline':'mdi-eye-off-outline'" class="ma-1 cursor-pointer" :text="element.nm" @click="evt=>{
                      element.shown=!element.shown
                      setVisible(element.id,element.shown)
                    }"/>
                  </template>
                </draggableComponent>
                <v-alert block border="start" color="info" density="compact" class="ma-1 cursor-pointer" :text=" $t('backgroundmap')"
                :icon="meta.basemapgroup.getLayersArray().some(lyr=>lyr.getVisible())?'mdi-eye-outline':'mdi-eye-off-outline'"
                @click="()=>{
                  if(meta.basemapgroup.getLayersArray().some(lyr=>lyr.getVisible()))bgselector.hideAll()
                  else bgselector.selBgMap(meta.selbgmid)
                }"/>
              </Pane>
            </Splitpanes>
          </v-card-text>
        </v-card>
      </div>
      <div class="editsv_right">
        <div class="bgselwrap">
          <BgMapSelector ref="bgselector" :map="meta.map" width="100%" :onLoad="(bgms)=>meta.bgms=bgms" :onUpdate="bid=>meta.selbgmid=bid"/>
        </div>
        <div id="editmap" class="w-100 h-100" :style="'border: 4px solid '+(meta.onediting?'red':'white')+';'"/>
        <v-icon :icon="'mdi-chevron-'+(meta.showleft?'left':'right')" class="editsv_left_tglbtn" @click="meta.showleft=!meta.showleft"/>
        <v-card v-if="meta.selsv&&meta.showdetail" position="absolute" width="320" class="editsv_detail">
          <v-card-title>
            <v-row>
              <v-col>{{ $t('sv_detail_edit') }} <span class="text-subtitle-2">{{ meta.selsv.processstatus!='complete'?`(${$t(meta.selsv.processstatus)})`:'' }}</span></v-col>
              <v-col cols="2" class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" style="z-index: 3000;" @click="meta.showdetail=false;sub()"/>
              </v-col>
            </v-row>
            <v-divider class="mt-3"/>
            <v-tabs fixed-tabs :items="['svinfo','svedit']" v-model="meta.seldetailtab" color="deep-purple-accent-4"
              @update:model-value="val=>{meta.onediting=val=='svedit';toggleEdit();}">
              <v-tab value="svinfo">{{ $t('svinfo') }}</v-tab>
              <v-tab value="svedit">{{ $t('svedit') }}</v-tab>
            </v-tabs>
          </v-card-title>
          <v-card-text>
            <v-tabs-window class="pt-3 ps-1 pe-1" v-model="meta.seldetailtab">
              <v-tabs-window-item value="svinfo" class="overflow-y-auto" style="height: calc(100vh - 255px);">
                <div class="svinfo_detail">
                  <v-defaults-provider :defaults="{VSelect:{hideDetails:true,variant:'outlined',density:'compact'},VTextField:{variant:'outlined',density:'compact'}}">
                    <v-row no-gutters class="mb-4">
                      <v-col>
                        <v-select :disabled="meta.onediting" :items="meta.data" v-model="meta.selsv.groupid" :label="$t('groupname')" :item-props="item=>({title:item.name,value:item.id})"/>
                      </v-col>
                    </v-row>
                    <v-row no-gutters v-if="meta.selsv.etc!=null">
                      <v-col><v-text-field :disabled="meta.onediting" :label="$t('newgroupname')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.selsv.etc"/></v-col>
                    </v-row>
                    <v-row no-gutters>
                      <v-col><v-text-field :disabled="meta.onediting" :label="$t('streetview_name')" maxlength="50" :placeholder="$t('enteranameforyourgroupupto50characters')" :rules="[validators.required]" v-model="meta.selsv.nm"/></v-col>
                    </v-row>
                    <v-row>
                      <v-col>
                        <v-select :disabled="true" class="mb-4" :items="meta.epsgs" v-model="meta.selsv.epsg" :label="$t('coordinatesystem')" :item-props="item=>({title:'EPSG:'+item,value:item})"/>
                      </v-col>
                    </v-row>
                    <p>{{ $t('managingstylesfieldinformation') }}</p>
                    <v-row>
                      <v-col class="ms-1 me-1">
                        <v-btn :disabled="meta.onediting" block prepend-icon="mdi-map-marker-check-outline" :text="$t('chooseastyle')" @click="sub('selstyle')"/>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col align-self="center">{{ $t('itemlist') }} <!--<span v-if="meta.totalFeatures!=null&&!meta.onediting">({{meta.numberReturned}}/{{meta.totalFeatures}})</span>--></v-col>
                      <!-- <v-col><v-switch hide-details color="primary" :label="$t('mapeditmode')" v-model="meta.onediting" @update:model-value="toggleEdit"/></v-col> -->
                    </v-row>
                    <v-card v-if="!meta.onediting&&meta.pteditlayer" flat>
                      <div class="edititemtbl">
                        <table>
                          <thead>
                            <tr>
                              <th></th>
                              <th>No.</th>
                              <th>TYPE</th>
                              <th>ID</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr v-for="row in meta.pteditlayer.getSource().getFeatures().filter(fea=>!fea.get('mergefid')||fea.get(fidnm)==fea.get('mergefid')).map((fea,idx)=>({no:idx+1,type:meta.selsv.layertype,id:fea.get(fidnm)}))"
                              @click="actSelFid(row.id)">
                              <td><input type="radio" name="selfid" :value="row.id" :checked="row.id==meta.selfid"/></td>
                              <td>{{ row.no }}</td>
                              <td>{{ $t('Point') }}</td>
                              <td>{{ row.id }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </v-card>
                    <p>{{ $t('svsharingdatadetails') }}</p>
                    <v-row>
                      <v-col class="ms-1 me-1">
                        <v-btn :disabled="meta.onediting" block :text="$t('managesvsharing')" @click="sub('share')"/>
                      </v-col>
                      <v-col class="ms-1 me-1">
                        <v-btn :disabled="meta.onediting" block :text="$t('datadetails')" @click="sub('datadetail')"/>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="ms-1 me-1">
                        <v-btn :disabled="meta.onediting" block :text="$t('viewlogs')" @click="sub('log')"/>
                      </v-col>
                    </v-row>
                    <v-row style="border-top: 1px solid black;">
                      <v-col class="text-center">거리뷰<br>방향 보기</v-col>
                      <v-col cols="7">
                        <v-switch hide-details density="compact" color="error" v-model="meta.isarrow" @update:model-value="toggleArrowStyle">
                          <template #prepend>
                            <label>일반&nbsp;</label>
                          </template>
                          <template #append>
                            <label>화살표</label>
                          </template>
                        </v-switch>
                      </v-col>
                    </v-row>
                  </v-defaults-provider>
                </div>
              </v-tabs-window-item>
              <v-tabs-window-item value="svedit">
                <v-divider/>
                <v-btn-toggle v-if="meta.onediting&&meta.selsv?.layertype=='NodeLink'" :model-value="meta.subeditmode" divided mandatory class="d-flex w-100"
                  @update:model-value="setSubEditMode">
                  <v-btn value="Node" class="flex-grow-1">
                    <v-icon>mdi-vector-point</v-icon>
                    <span class="hidden-sm-and-down">{{ $t('Node') }}</span>
                  </v-btn>
                  <v-btn value="Link" class="flex-grow-1">
                    <v-icon>mdi-vector-line</v-icon>
                    <span class="hidden-sm-and-down">{{ $t('Link') }}</span>
                  </v-btn>
                </v-btn-toggle>
                <v-divider/>
                <v-row align="center">
                  <v-col cols="9">{{ $t('modify') }}/{{ $t('new') }}</v-col>
                  <v-col>
                    <v-switch v-if="meta.onediting" hide-details density="comfortable" color="error" :model-value="meta.editmode=='add'" :disabled="meta.disableaddmode"
                      @update:model-value="val=>setEditMode(val?'add':'mod')"/>
                  </v-col>
                </v-row>
                <v-divider/>
                <v-row class="mt-1">
                  <v-col cols="2">범례</v-col>
                  <v-col class="text-right">
                    <v-icon icon="mdi-circle" style="color: rgba(255, 50, 50, 1.0);"/>{{ $t('new') }}
                    <v-icon icon="mdi-circle" style="color: rgba(0, 90, 255, 1.0);"/>{{ $t('selection') }}
                    <v-icon icon="mdi-circle" style="color: rgba(255, 140, 0, 1.0);"/>{{ $t('modify') }}
                  </v-col>
                </v-row>
                <v-row><v-col>
                  <v-btn v-if="meta.featureselected" block color="error" :text="$t('delete')" @click="delSelFeature"/>
                </v-col></v-row>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-card-text>
          <v-card-actions style="position: absolute;left: 0;right: 0;bottom: 0;">
            <v-row>
              <v-col><v-btn block variant="elevated" :text="$t('cancel')" @click="meta.showdetail=false"/></v-col>
              <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="sub('mod')"/></v-col>
            </v-row>
          </v-card-actions>
          <v-overlay contained v-model="meta.blockdetail" persistent/>
        </v-card>
        <v-card v-if="meta.showsub&&meta.showdetail&&meta.subtype=='featuredetail'" position="absolute" width="350px" class="editsv_featuredetail">
          <v-card-title>
            <v-row>
              <v-col>{{$t('viewsvdetails')}}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="actSelFid()"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-defaults-provider :defaults="{global:{hideDetails:true,variant:'outlined',density:'compact'},VNumberInput:{inset:true}}">
              <v-textarea class="mt-3 mb-3" label="URL 링크" v-model="meta.modifyfeature.featurelink"/>
              <v-textarea class="mt-3 mb-3" :label="$t('memo')" :placeholder="$t('pleaseenteradescriptionupto50characters')" v-model="meta.modifyfeature.memo"/>
              <v-number-input class="mb-3" :step="0.00001" :precision="5" :label="$t('xcoordinate')" v-model="meta.modifyfeature.coords[0]"/>
              <v-number-input class="mb-3" :step="0.00001" :precision="5" :label="$t('ycoordinate')" v-model="meta.modifyfeature.coords[1]"/>
              <v-number-input class="mb-3" :step="0.01" :precision="2" :label="$t('hangle')" v-model="meta.modifyfeature.hangle"/>
              <v-number-input :step="0.01" :precision="2" :label="$t('vangle')" v-model="meta.modifyfeature.vangle"/>
              <v-switch hide-details density="compact" color="primary" class="mt-1 mb-1" :disabled="!meta.modifyfeature.overlapped" v-model="meta.modifyfeature.setptmerge">
                <template #prepend>
                  <label class="cursor-pointer" style="width: 130px;" @click="meta.modifyfeature.setptmerge=false">{{ $t('discon_pt') }}</label>
                </template>
                <template #append>
                  <label class="cursor-pointer" @click="meta.modifyfeature.setptmerge=true">{{ $t('con_pt') }}</label>
                </template>
              </v-switch>
            </v-defaults-provider>
            <v-divider/>
            <v-row class="mt-3">
              <v-col>{{$t('pano')}} {{ $t('lists') }}</v-col>
              <v-col class="text-right"><v-btn color="primary" density="compact" :text="$t('pano_add')" @click="modFeature('addpanopop')"/></v-col>
            </v-row>
            <v-btn v-if="meta.panos&&meta.panos.length>1" block density="compact" color="secondary" class="mt-2 mb-2" :text="$t('compareroadview')" @click="panoViewerCompare(meta.modifyfeature.hangle,meta.modifyfeature.vangle)"/>
            <div class="pano_list pa-1">
              <v-expansion-panels class="mt-3" v-if="meta.panos" variant="accordion">
                <v-expansion-panel v-for="pano in meta.panos" :title="ymdhm(pano.imgdt)">
                  <v-expansion-panel-text>
                    <img style="max-width: 100%;max-height: 100%;" :src="config.backend+'panofile/'+pano.id+'/files/tiles/thumb.jpg'"/>
                    <v-row>
                      <v-col class="text-end">
                        <v-btn density="compact" class="me-2" :text="$t('preview')" @click="panoViewerSingle(pano.id,meta.modifyfeature.hangle,meta.modifyfeature.vangle)"/>
                        <v-btn density="compact" class="me-2" color="error" :text="$t('delete')" @click="meta.selpano=pano;modFeature('delpanopop')"/>
                        <v-btn density="compact" color="primary" :text="$t('modify')" @click="meta.selpano=pano;modFeature('modpanopop')"/>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-text>
                </v-expansion-panel>
              </v-expansion-panels>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-row>
              <v-col cols="3"><v-btn block :text="$t('cancel')" variant="elevated" @click="actSelFid()"/></v-col>
              <v-col cols="3"><v-btn block :text="$t('delete')" color="error" variant="elevated" @click="modFeature('delpop')"/></v-col>
              <v-col><v-btn block :text="$t('save')" variant="elevated" color="primary" @click="modFeature('modpop')"/></v-col>
            </v-row>
          </v-card-actions>
          <v-overlay contained class="align-center justify-center" v-model="meta.featuremodpop" persistent>
            <v-progress-circular v-if="meta.modfeaturetype=='loading'" color="primary" size="64" indeterminate/>
            <v-card v-if="meta.modfeaturetype=='addpanopop'||meta.modfeaturetype=='modpanopop'" width="340px">
              <v-card-title>
                <v-row>
                  <v-col>{{$t('pano')}} {{ $t(meta.modfeaturetype=='addpanopop'?'add':'modify') }}</v-col>
                  <v-col class="text-right">
                    <v-btn variant="text" density="compact" icon="mdi-close" @click="modFeature()"/>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-date-input hide-details class="ma-3" variant="outlined" density="compact" prepend-icon="" prepend-inner-icon="mdi-calendar" :label="$t('datetaken')" v-model="meta.selpano.imgdt"/>
                <v-file-input hide-details class="ma-3" show-size variant="outlined" density="compact" prepend-icon="" prepend-inner-icon="mdi-file" :label="$t('uploadfile')" v-model="meta.selpano.upimgpano" @update:model-value="previewPanoImg"/>
                <v-number-input hide-details class="ma-3" variant="outlined" density="compact" :step="0.01" :label="$t('hangle')" v-model="meta.selpano.hangle"/>
                <v-number-input hide-details class="ma-3" variant="outlined" density="compact" :step="0.01" :label="$t('vangle')" v-model="meta.selpano.vangle"/>
                <img ref="modpanoimg" :style="{maxWidth:'100%',maxHeight:'100%',display:'none'}"/>
              </v-card-text>
              <v-card-actions>
                <v-row>
                  <v-col><v-btn block variant="elevated" :text="$t('cancel')" @click="modFeature()"/></v-col>
                  <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="modFeature('modpano')" :disabled="!meta.selpano.imgdt"/></v-col>
                </v-row>
              </v-card-actions>
            </v-card>
            <ConfirmCard v-if="meta.modfeaturetype=='delpop'||meta.modfeaturetype=='modpop'||meta.modfeaturetype=='delpanopop'" :ttl="$t(meta.modfeaturetype.includes('pano')?'pano_'+meta.modfeaturetype.replace('panopop',''):'viewsvdetails')"
              :cont="meta.modfeaturetype.replace('pop','').replace('pano','')" :min-width="300" @cancel="modFeature()" @confirm="modFeature(meta.modfeaturetype.replace('pop',''))"/>
          </v-overlay>
        </v-card>
        <v-card v-if="meta.showdetail&&meta.subtype&&meta.subtype!='featuredetail'&&meta.subtype!='mod'&&meta.subtype!='share'" class="subcard">
          <v-card-title>
            <v-row>
              <v-col>{{ meta.subttl }}</v-col>
              <v-col class="text-right">
                <v-btn variant="text" density="compact" icon="mdi-close" @click="sub()"/>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text  style="height: 450px;">
            <div v-if="meta.subtype=='selstyle'">
              <v-row>
                <v-col>
                  <v-tabs v-model="meta.selstyletype">
                    <v-tab v-for="type in ['Streetview','Manual']" :value="type" @click="searchStyle">
                      {{ $t(type=='Manual'?'sldstylefiles':type) }}
                    </v-tab>
                  </v-tabs>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn :text="$t('managestyles')+' '+$t('shortcuts')" @click="openManStyle"/>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-text-field hide-details variant="outlined" density="compact" :label="$t('stylename')" :placeholder="$t('enteranameforyourstyle')" v-model="meta.searchstylenm" @keyup.enter="searchStyle"/>
                </v-col>
                <v-col cols="1"><v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="searchStyle"/></v-col>
                <v-col class="text-right">
                  <v-btn class="me-3" :text="$t('refresh')" @click="searchStyle"/>
                  <v-btn color="primary" :text="$t('applying')" @click="saveSvStyle"/>
                </v-col>
              </v-row>
              <v-table class="editstyletbl" height="320">
                <thead>
                  <tr>
                    <th style="width: 20px;"></th>
                    <th v-for="head in meta.styleheads">{{ $t(head.tk) }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!meta.styles.rows.length"><td :colspan="meta.styleheads.length+1" class="text-center">{{ $t('noresultsfound') }}</td></tr>
                  <tr v-else v-for="row in meta.styles.rows">
                    <td><v-checkbox hide-details density="compact" :value="row.gsstylenms" v-model="meta.selstyle"/></td>
                    <td v-for="head in meta.styleheads" class="text-center">
                      <div v-if="head.tk=='preview'&&row.styletype=='Streetview'">
                        <img style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id+'/Point'"/>
                        <img style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id+'/LineString'"/>
                      </div>
                      <img v-else-if="head.tk=='preview'&&row.styletype=='Manual'" style="max-width: 50px;max-height: 50px;" :src="config.backend+'previewstyle/'+row.id"/>
                      <div v-else-if="head.col=='mdt'">{{ ymd(row[head.col]) }}</div>
                      <div v-else-if="head.col=='groupid'">{{ row.groupid?meta.styles.subrows.groups.find(group=>group.id==row.groupid).nm:$t('defaultgroups') }}</div>
                      <div v-else>{{ row[head.col] }}</div>
                    </td>
                  </tr>
                </tbody>
              </v-table>
            </div>
            <DataDetail v-if="meta.subtype=='datadetail'" :id="meta.selsv.id" type="sv" tblheight="210"/>
            <Logs v-if="meta.subtype=='log'" ispop logcate="Streetview" :targetid="meta.selsv.id" :hideclose="true"/>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </MenuLayout>
  <Teleport v-if="meta.subtype=='share'" to="#popbody">
    <MemPicker tkey="sharingsv" refnm="streetview" :refid="meta.selsv.id" auth="ADMIN,MEMBER" :targettypes="['all','partial']" :targettype="meta.selsv.sharetype" @close-pop="sub()" @save-callback="shareSaved"/>
  </Teleport>
  <Teleport v-if="meta.subtype=='mod'" to="#popbody">
    <v-card class="mx-auto" :min-width="350" :title="$t('savesv')">
      <v-divider/>
      <v-card-text>
        <p v-if="meta.selsv&&meta.selsv.layertype=='LineString'&&meta.modeditfeatures.mods.length>0" class="text-pink mb-3">
          등록된 선을 수정하면 선에 포함된 모든 데이터가 삭제됩니다.<br/>(예: 파노라마, 링크등)
        </p>
        <p>{{ $t('save_con') }}</p>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-row justify="end">
          <v-btn :text="$t('cancel')" variant="outlined" @click.stop="sub()"/>
          <v-btn :text="$t('confirm')" class="ms-2 me-3" variant="elevated" color="primary" @click.stop="modSv"/>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
<style>
.editsv{display: flex;flex-wrap: nowrap;height: 100%;}
.editsv_left{width: 350px;}
.editsv_left > .v-card{height: calc(100% - 10px);margin: 5px 0 5px 2px;}
.editsv_left_tglbtn{cursor: pointer;position: absolute;color:#fff;background-color: #3F51B5;width: 20px;height: 82px;top:0;left: 0;z-index: 9;}
.editsv_right{flex-grow: 1;position: relative;}
.editsv .splitpanes{height: calc(100vh - 90px);}
.editsv .splitpanes__pane{background-color: #fff !important;overflow-y: auto;}
.editsv .splitpanes__splitter {min-height: 12px !important;}
.editsv .bgselwrap{position: absolute;z-index: 999;top: 6px;left: 28px;width: 292px;}
#editmap{position: relative;z-index: 1;}
#editmap .ol-zoom{left: auto;right: 5px;}
#editmap .ol-zoomslider{left: auto;right: 5px;}
.svinfo_detail{width: 95%;height: 100%;padding-top: 20px;}
.editsv .subcard{position: absolute;bottom: 2px;right: 5px;z-index: 10;width: calc(100% - 326px);height: 500px;}
.editsv_detail{top: 82px;left: 0;z-index: 10;height: calc(100% - 86px);}
.editsv_detail p{margin: 10px 0 10px 0;}
.edititemtbl{border: 1px solid #797979;overflow-y: auto;height: 350px;}
.edititemtbl table{border-collapse: collapse;min-width: 100%;}
.edititemtbl th{height: 30px !important;text-align: center !important;background-color: #f2f2f2 !important;border-collapse: collapse;border: 1px solid #e0e0e0;}
.edititemtbl td{white-space: nowrap;text-align: center;border: 1px solid #e0e0e0;padding: 5px;cursor: pointer;}
.edititemtbl tr:has(:checked){background-color: #E8EAF6;}
.editstyletbl,.editmetatbl{border: 1px solid #e0e0e0;margin-top: 10px;}
.editstyletbl th{height: 40px !important;background-color: #eee !important;text-align: center !important; width: 180px;}
.editmetatbl th{width: 130px;background-color: #f2f2f2;}
.vue3-tree-vue span{user-select: none;}
.ol-attribution{display: none;}
.ol-mouse-position{top:auto;bottom: 0;}
.editsv_featuredetail{top: 56px;right: 36px;z-index: 10;height: calc(100% - 320px);}
.editsv_featuredetail .v-card-text{height: calc(100% - 100px);overflow-y: auto;}
.editsv_featuredetail .v-number-input__control button{border-width: 0 !important;}
.editsv .tree-item-node-parent{width: 100%;}
.editsvtree .tree-item .d-flex > span{width: 150px;}
</style>
